import {
  AUSTRALIA_TERRITORIES,
  CANADA_PROVINCES,
  COUNTRY_CODES_WITH_NAMES,
  US_STATES_WITH_CODES,
} from 'controllers/constants';

export const COUNTRY_OPTIONS = COUNTRY_CODES_WITH_NAMES.map(
  ({ countryCode, countryName }) => ({
    label: countryName,
    value: countryCode,
  }),
);

export const SUPPORTED_COUNTRY_REGIONS: { [key: string]: any[] } = {
  US: US_STATES_WITH_CODES,
  CA: CANADA_PROVINCES,
  AU: AUSTRALIA_TERRITORIES,
};

// Free email domains that should show a warning
export const FREE_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'aol.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'comcast.net',
  'verizon.net',
  'att.net',
  'sbcglobal.net',
  'bellsouth.net',
];
